import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import Modal from '../../../../core/modules/common/components/Modal';
import Button from '../../../../core/modules/common/components/Button';
import { editAdminReportRequestActionCreator } from '../../../admin/dashboard/redux/actions/AdminDashboardActions';
import { getAdminReportCategory, getAdminReports } from '../../../admin/dashboard/redux/selectors/AdminDashboardSelectors';
import themeStyles from '../../../../materialUiTheme';

// eslint-disable-next-line react/prefer-stateless-function
class AdminReportSettingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportId: '',
      reportName: '',
      reportCategory: '',
      reportCode: '',
      reportTags: [],
    };
  }

  componentDidMount() {
    this.propsToState();
  }

  propsToState = () => {
    const { currentReport, categoryGroup } = this.props;
    const defaultCategory = categoryGroup.filter(option => option.value === currentReport.reportCategory.categoryId);
    const transformedDefaultTags = currentReport.reportTags.map(({ categoryId, name }) => ({ value: categoryId, label: name }));
    this.setState({
      reportId: currentReport.reportNo,
      reportName: currentReport.reportName,
      reportCategory: defaultCategory[0],
      reportTags: transformedDefaultTags,
      reportCode: currentReport.reportCode,
    });
  };

  reportIdChange = (e) => {
    this.setState({
      reportId: e.target.value,
    });
  };

  reportNameChange = (e) => {
    this.setState({
      reportName: e.target.value,
    });
  };

  reportCategoryChange = (e) => {
    this.setState({
      reportCategory: e,
    });
  };

  reportTagChange = (e) => {
    this.setState({
      reportTags: e,
    });
  };

  save = () => {
    const {
      reportId,
      reportName,
      reportCategory,
      reportTags,
      reportCode,
    } = this.state;
    const transformedReportTags = reportTags.map(({ value, label }) => ({ categoryTagId: value, name: label, mainCategory: 0 }));
    const newObj = {
      reportNo: reportId,
      reportName,
      reportCategory: {
        categoryTagId: reportCategory.value,
        name: reportCategory.label,
        mainCategory: 1,
      },
      reportTags: transformedReportTags,
    };
    this.props.editAdminReportRequestActionCreator(reportCode, newObj);
    this.props.onCloseModal();
  };

  render() {
    const {
      reportId,
      reportName,
      reportCategory,
      reportTags,
    } = this.state;
    const {
      onCloseModal,
      categoryGroup,
    } = this.props;
    return (
      <div className="admin-modal">
        <Modal
          closeOnOutsideClick
          onClose={onCloseModal}
        >
          <div className="report-modal">
            <table>
              <tr>
                <td className="first-td">ID:</td>
                <td className="second-td"><input value={reportId} onChange={this.reportIdChange} /></td>
              </tr>
              <tr>
                <td className="first-td">Report name:</td>
                <td className="second-td"><input value={reportName} onChange={this.reportNameChange} /></td>
              </tr>
              <tr>
                <td className="first-td">Report category*:</td>
                <td className="second-td"><Select options={categoryGroup} value={reportCategory} onChange={this.reportCategoryChange} /></td>
              </tr>
              <tr>
                <td className="first-td">Report tags*:</td>
                <td className="second-td"><Select multi options={categoryGroup} value={reportTags} onChange={this.reportTagChange} /></td>
              </tr>
            </table>
            <div className="button-div">
              <Button className="left-btn" text="app.button.cancel" onClick={onCloseModal} />
              <Button text="app.button.save" style={themeStyles.blueButton} onClick={this.save} />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

AdminReportSettingModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  currentReport: PropTypes.objectOf(PropTypes.shape),
  categoryGroup: PropTypes.objectOf(PropTypes.shape),
  editAdminReportRequestActionCreator: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  editAdminReportRequestActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  adminReports: getAdminReports(state),
  reportCategory: getAdminReportCategory(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminReportSettingModal);
